import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

@Component({
  //selector: 'app-faicon',
  selector: 'fa-icon',
  template: `
    <span class="fa-icon" [innerHTML]="svg"></span>
  `,
  styleUrls: ['./faicon.component.scss'],
  standalone: true
})
export class FaiconComponent  implements OnChanges {
  @Input() icon!: IconDefinition;
  svg: SafeHtml = '';

   constructor(private sanitizer: DomSanitizer) {}

  ngOnChanges(changes: SimpleChanges) {
    if (this.icon) {
      /*
      this.svg = this.convertToSvg(this.icon);
      */
      const rawSvg = this.convertToSvg(this.icon);
      this.svg = this.sanitizer.bypassSecurityTrustHtml(rawSvg);
      //console.log('Rendered SVG:', this.svg);
    }
  }

  private convertToSvg(icon: IconDefinition): string {
    const [width, height, , , path] = icon.icon;
    return `
      <svg viewBox="0 0 ${width} ${height}" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" preserveAspectRatio="xMidYMid meet" style="display: block;">
        <path d="${path}"></path>
      </svg>
    `;
  }
}
